<template>
  <div>
    <Navbar />
    <section class="category-page">
      <Header
        formID="get-offer-foreign"
        :formData="formData"
        :insuranceType="insuranceType"
        approveRoute="yabanci-saglik-teklif-onay"
      />
    <app-customer-comments />
      <get-quote :quoteCard="quoteCard" />
      <category-info :categoryInfo="categoryInfo" />
      <app-contracted-insurance-companies :buttons="buttonData" />
      <frequently-asked-questions
        :faqTitle="faqTitle"
        :faqTitleDesc="faqTitleDesc"
        :questions="questions"
      />
    </section>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/component/navbar/Navbar'
import Header from '@/component/categories/Header'
import GetQuote from '@/component/categories/GetQuote'
import categoryInfo from '@/component/categories/CategoryInfo'
import appContractedInsuranceCompanies from '@/component/contracted-insurance-companies/AppContractedInsuranceCompanies'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import ForeignHealthInsuranceData from '@/data/category-page-data/ForeignHealthInsurance'
import appCustomerComments from "@/component/customer-comments/AppCustomerComments"
import Footer from '@/component/footer/Footer'
import QuotationType from '@/data/QuotationType'
import { filteredButtons } from '@/mixins/FilteredButtons'

export default {
  metaInfo: {
    title: 'En Uygun Yabancı Uyruklu Sağlık Sigortası Fiyatları',
    meta: [
      {
        name: 'description',
        content:
          'Oturma izni ya da ikamet tezkeresi için gerekli şartları karşılayan sigorta poliçesini satın almak için yabancı uyruklu sağlık sigortası fiyatlarını karşılaştırın.'
      }
    ]
  },
  mixins: [filteredButtons],
  name: 'CreditInsurance',
  components: {
    Navbar,
    Header,
    GetQuote,
    categoryInfo,
    appContractedInsuranceCompanies,
    frequentlyAskedQuestions,
    Footer,
    appCustomerComments
  },
  data () {
    return {
      insuranceType: QuotationType.FOREIGN,
      categoryInfo: ForeignHealthInsuranceData.categoryInfo,
      getPrice: ForeignHealthInsuranceData.getPrice,
      faqTitle: ForeignHealthInsuranceData.faqTitle,
      faqTitleDesc: ForeignHealthInsuranceData.faqTitleDesc,
      questions: ForeignHealthInsuranceData.questions,
      formData: {
        description: {
          upperText: 'En Uygun',
          title: 'Yabancı Uyruklu Sağlık Sigortası Ücretleri',
          bottomText: 'Teklif Alın, Fiyatları Karşılaştırın'
        },
        button: 'TEKLİF AL',
        fullname: true,
        identity: true,
        phone: true,
        email: true
      },
      quoteCard: {
        title: 'Alokasko İle Yabancı Uyruklu Sağlık Sigortası Almak Çok Kolay!',
        description:
          'Oturma izni veya ikamet tezkeresi için yabancı kişilerin yaptırması gereken sağlık sigortası.',
        content: [
          {
            id: 1,
            icon: 'fas fa-file-alt',
            title: 'Avantajlı Teminatlar',
            desc:
              'Türkiye’ye gelecek yabancılar için hazırlanmış avantajlı teminat ile ayakta veya yatarak tedaviler, doktor muayeneleri, ilaç masrafları karşılanır. '
          },
          {
            id: 2,
            icon: 'fab fa-cc-visa',
            title: 'Anlaşmalı Sağlık Kuruluşu Ağı',
            desc:
              'Türkiye genelinde yaygın anlaşmalı sağlık kuruluş ağı ile pek çok hastaneden hizmet alabilirsiniz.'
          },
          {
            id: 3,
            icon: 'fas fa-clipboard-check',
            title: 'Özel İndirim',
            desc:
              'Online teklif alarak özel indirimlerden yararlanabilirsiniz. Üstelik poliçenizi satın alma aşamasında uzmanlarımız size destek olur.'
          },
          {
            id: 4,
            icon: 'fas fa-users-cog',
            title: 'Çeşitli Ödeme',
            desc:
              'İhtiyaca göre kendi poliçenizi oluşturabilir, avantajlı ödeme ile poliçenizi alarak güvencenizi başlatabilirsiniz.'
          }
        ]
      }
    }
  },
  mounted () {
    this.filterButtons('Yabancı Sağlık Sigortası');
    (function() {
      const s1 = document.createElement("script"); const s0 = document.getElementsByTagName("script")[0];
      s1.async = true;
      s1.src = 'https://embed.tawk.to/61b20a97c82c976b71c09617/1fmfniob6';
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');
      s0.parentNode.insertBefore(s1, s0);
    })();
  }
}
</script>
<style lang="scss">
@import '@/css/app.scss';
</style>
